
import { useState, useEffect } from "react";
import { Group, Product } from "@/lib/types";
import { fetchGroups } from "@/lib/storage/group/api";
import { fetchProductsFromApi } from "@/lib/storage/product/api";
import { getGroups, getProducts } from "@/lib/storage";
import { useToast } from "@/hooks/use-toast";
import { getUser } from "@/lib/storage";

export const useGroupsLoading = (navigate: (path: string) => void) => {
  const [groups, setGroups] = useState<Group[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      
      const user = getUser();
      if (!user) {
        navigate("/");
        return;
      }

      try {
        // Load groups and products from API (which includes remote data)
        console.log("Fetching groups from API...");
        const loadedGroups = await fetchGroups(true);
        console.log(`Retrieved ${loadedGroups.length} groups from API`);
        
        console.log("Fetching products from API...");
        const loadedProducts = await fetchProductsFromApi(true);
        console.log(`Retrieved ${loadedProducts.length} products from API`);
        
        setGroups(loadedGroups);
        setProducts(loadedProducts);
      } catch (error) {
        console.error("Error loading data:", error);
        // Fallback to local storage
        console.log("Falling back to local storage for groups and products");
        const localGroups = getGroups();
        const localProducts = getProducts();
        setGroups(localGroups);
        setProducts(localProducts);
        
        toast({
          title: "Connection issue",
          description: "Using locally stored data. Some changes may not be saved.",
          variant: "destructive",
        });
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, [navigate, toast]);

  return { groups, products, isLoading, setGroups, setProducts };
};
